import ApiProviderNodary from '../logos/api-provider/Nodary.svg';
import ApiProviderBlocksize from '../logos/api-provider/Blocksize.svg';
import ApiProviderCoingecko from '../logos/api-provider/Coingecko.svg';
import ApiProviderDxfeed from '../logos/api-provider/Dxfeed.svg';
import ApiProviderFinage from '../logos/api-provider/Finage.svg';
import ApiProviderNcfx from '../logos/api-provider/Ncfx.svg';
import ApiProviderShiftmarkets from '../logos/api-provider/Shiftmarkets.svg';
import ApiProviderAlchemy from '../logos/api-provider/Alchemy.svg';
import ApiProviderAnkr from '../logos/api-provider/Ankr.svg';
import ApiProviderDrpc from '../logos/api-provider/Drpc.svg';
import ApiProviderInfura from '../logos/api-provider/Infura.svg';
import ApiProviderCoinpaprika from '../logos/api-provider/Coinpaprika.svg';
import ApiProviderKaiko from '../logos/api-provider/Kaiko.svg';
import ApiProviderCoinmetrics from '../logos/api-provider/Coinmetrics.svg';
import ApiProviderTwelvedata from '../logos/api-provider/Twelvedata.svg';
import ApiProviderPlaceholder from '../logos/api-provider/Placeholder.svg';
function sanitizeName(id) {
  return id.replace(/\s+|-/g, '').replace(/ExchangeRate/g, '');
}
function ApiProviderLogo(id, light = false) {
  if (!id) {
    return ApiProviderPlaceholder;
  }
  switch (sanitizeName(`${id}${light ? "light" : ""}`).toLowerCase()) {
    case "nodary":
      return ApiProviderNodary;
    case "blocksize":
      return ApiProviderBlocksize;
    case "coingecko":
      return ApiProviderCoingecko;
    case "dxfeed":
      return ApiProviderDxfeed;
    case "finage":
      return ApiProviderFinage;
    case "ncfx":
      return ApiProviderNcfx;
    case "shiftmarkets":
      return ApiProviderShiftmarkets;
    case "alchemy":
      return ApiProviderAlchemy;
    case "ankr":
      return ApiProviderAnkr;
    case "drpc":
      return ApiProviderDrpc;
    case "infura":
      return ApiProviderInfura;
    case "coinpaprika":
      return ApiProviderCoinpaprika;
    case "kaiko":
      return ApiProviderKaiko;
    case "coinmetrics":
      return ApiProviderCoinmetrics;
    case "twelvedata":
      return ApiProviderTwelvedata;
    default:
      return light ? ApiProviderLogo(id) : ApiProviderPlaceholder;
  }
}
export default ApiProviderLogo;